<div class="pagination-container">
    <button class="nav-button prev" (click)="atraspagina()" [disabled]="pagine === 0">
        <i [class]="arrowleft"></i>
    </button>

    <div class="page-numbers">
        <div *ngFor="let pagina of paginasVisibles" [class.active]="pagina.activa" class="page-number noselect"
            (click)="activarPagina(pagina)">
            {{pagina.nombre}}
        </div>
    </div>

    <button class="nav-button next" (click)="adelantarpagina()" [disabled]="pagine >= paginas - 1">
        <i [class]="arrowright"></i>
    </button>
</div>